import React from 'react';
import PropTypes from 'prop-types';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      select: ({ data }) => data,
      retry: false,
    },
  },
});

const ReactQueryProvider = props => (
  <QueryClientProvider client={queryClient}>
    {props.children}
    {__DEV__ ? <ReactQueryDevtools initialIsOpen={false} /> : null}
  </QueryClientProvider>
);

ReactQueryProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ReactQueryProvider;
